import { DatePipe } from '@angular/common';
import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CheckSVTStatus, CustomerDetailsService } from 'src/app/core';
import { PopUpId } from 'src/app/core/models/enum/PopUpId.enum';
import { HistoryEventType } from '../../../core/models/customer-details';
import { DashboardService } from '../../services/dashboard.service';

import { ERROR_MESSAGES } from './../../../constants/error-messages.constants';
import { CONSTANTS } from './../../../constants/constants';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-dialog-box',
  templateUrl: './dialog-box.component.html',
  styleUrls: ['./dialog-box.component.less'],
  standalone: false
})
export class DialogBoxComponent implements OnInit {

  @Input() public modalConfig;
  public pageTitleClass = '';
  public svtCheckStatus = false;
  public currentSVTStatus = '';
  public eventHistory: any = {};
  private element: any;
  public pageTitle: any;
  public startDate: Date;
  public endDate: Date;
  public dob: Date;
  public svterror = false;
  public errorMessage;
  public responseReceived = false;
  public showDateErrMsg = false;
  public oneTimeStartOrStopSVT = false;
  public page = 1;
  public isSVTPopUp = false;
  public svtdetailsformgroup: UntypedFormGroup;
  public callBacketailsformgroup: UntypedFormGroup;
  public errorMessages; // Form validation messages
  public key;
  public callBackValues = {
    type: '',
    date: '',
    time: '',
    hr: '',
    remarks: '',

  };
  public customerInfo = {
    emergencyContactDetails: [{emMobileNumber: ''}],
    otherVehicleDetails: [{}],
    secondaryContactDetails: [{mobileNo: ''}],
    securityAlarmDetails: [{}],
    dashboardInfo: {
      windowStatus: {
        frontWindowAS: { closeState: '' },
        rearWindowRR: { closeState: '' },
        rearWindowRL: { closeState: '' },
        frontWindowDR: { closeState: '' }
      },
      doorStatus: {
        firstRowDriver: { openState: '', lockState: '' },
        secondRowDriver: { openState: '', lockState: '' },
        hood: { openState: '' },
        trunk: { openState: '' },
        firstRowPassenger: { openState: '', lockState: '' },
        secondRowPassenger: { openState: '', lockState: '' }
      },
      lightStatus: {
        brightLights: { lightState: '' },
        headlights: { lightState: '' },
        rearFogLights: { lightState: '' },
        fogLights: { lightState: '' },
        parkingLights: { lightState: '' }
      },
    },
    tripInfo: [{}],
    rsaInfo: [{}],
    transInfo: [{}],
    trackingStatus: '',
    preferenceData: {
      preferredMethod: '',
      preferredContactDay: '',
      preferredContactStartTime: '',
      preferredContactEndTime: ''
    }
  };
  public serviceDetails: [{}];
  public insuranceDetails: [{}];
  public fuelLogDetails = [{}];
  public checkSVTStatus: CheckSVTStatus = {
    vinNumber: '',
    requestId: '',
    productOwnId: '',
    emailId: ''
  };
  public historyData: HistoryEventType = {
    eventType: '',
    fromDate: '',
    toDate: ''
  };
  public svtDetails = {
    vehRegNumber: '',
    dateOfBirth: '',
    vinNumber: '',
    primaryMobileNo: ''
  };
  public svtUserDetails = {
    firstName: '',
    lastName: '',
    emailId: '',
    primaryMobileNo: '',
    vinNumber: '',
    vehRegNumber: '',
    trackingStatus: '',
    productOwnId: '',
    customerId: '',
    requestId: '',
  };
  public popUpId: typeof PopUpId = PopUpId;
  public CONSTANTS = CONSTANTS;
  public maxDate: Date;
  public minDate: Date;
  public isFetechDateEnable = true;
  public svtLocationUrl: SafeUrl;
  public hr = [{ value: '', valueOption: 1 }];
  phone: any;
  public loggedInUserData: any;
  public emailId: string;
  public zeroResults = true;
  public callbackData: Array<any> = [];

  constructor(
    public activeModal: NgbActiveModal,
    private dashboardService: DashboardService,
    private router: Router,
    public datepipe: DatePipe,
    private customerDetailsService: CustomerDetailsService,
    private el: ElementRef,
    private formBuilder: UntypedFormBuilder,
    private sanitizer: DomSanitizer
  ) {
    this.element = el.nativeElement;
    this.errorMessages = ERROR_MESSAGES;
    this.maxDate = new Date();
    this.maxDate.setDate(this.maxDate.getDate());
    this.minDate = new Date();
    this.minDate.setDate(this.maxDate.getDate() + 1);

    for (let index = 0; index < 12; index++) {
      const value = (index + 1) + ':00 HR';
      this.hr[index] = { value, valueOption: index + 1 };
    }
  }
  // '1:00 HR', '2:00 HR', '3:00 HR', '4:00 HR', '5:00 HR', '6:00 HR', '7:00 HR', '8:00 HR', '9:00 HR', '10:00 HR', '11:00 HR', '12:00 HR'

  ngOnInit() {
    this._initializeControls();
    switch (this.modalConfig.popupId) {
      case PopUpId.EMERPOP: this.customerInfo.emergencyContactDetails = this.modalConfig.popUpContent; break;
      case PopUpId.OTHERVEHPOP: this.customerInfo.otherVehicleDetails = this.modalConfig.popUpContent; break;
      case PopUpId.SECCONTACTPOP: this.customerInfo.secondaryContactDetails = this.modalConfig.popUpContent; break;
      case PopUpId.PREFERPOP: this.setPreferencesPopUp(); break;
      case PopUpId.TRIPSCOREPOP: this.setTripScorePopUp(); break;
      case PopUpId.RSAPOP: this.setRSAPopUp(); break;
      case PopUpId.TRANSACTIONPOP: this.setTransactionsPopUp(); break;
      case PopUpId.FUELLOG: this.setFuelLogPopup(); break;
      case PopUpId.INSURANCEPOP: this.setInsurancePopup(); break;
      case PopUpId.CALLBACKPOP: this.setTransactionsPopUp(); break;
      case PopUpId.DASHBOARDPOP: this.setDashBoardPopUp(); break;
      case PopUpId.SERVICEHISTPOP: this.setServiceHistoryPopUp(); break;
      case PopUpId.ERRMSGPOP: this.errorMessage = this.modalConfig.popUpContent; break;
      case PopUpId.SVTSTATUSPOP:
        this.customerInfo.trackingStatus = this.modalConfig.popUpContent.trackingStatus === 'stop' ? 'OFF' : 'ON'; break;
      case PopUpId.SECURITYALARAMPOP: this.setSecurityAlaramDetails(); break;
      //case PopUpId.CTICALLBACK: this.callbackResults(); break;
      default: this.errorMessage = this.modalConfig.popUpContent; break;
    }
    this.pageTitle = this.modalConfig.popUpToShow;
    this.pageTitleClass = this.modalConfig.heading.split(' ').join('-').toLowerCase();
    this.emailId = localStorage.getItem('emailId') || '';
    const loggedInUserDataStr = localStorage.getItem('loggedInUserData');
    this.loggedInUserData = loggedInUserDataStr ? JSON.parse(loggedInUserDataStr) : null;

    // console.log('modalConfig : ', this.modalConfig, this.pageTitleClass);

    this.svtdetailsformgroup.get('vehicleno')?.valueChanges.forEach(val => {
      if (this.svtdetailsformgroup.get('vehicleno')?.value !== '') {
        this.svtdetailsformgroup.get('vinnumber')?.disable();
      } else if (this.svtdetailsformgroup.get('vehicleno')?.value === '') {
        this.svtdetailsformgroup.get('vinnumber')?.enable();
      }
    });

    this.svtdetailsformgroup.get('vinnumber')?.valueChanges.forEach(val => {
      if (this.svtdetailsformgroup.get('vinnumber')?.value !== '') {
        this.svtdetailsformgroup.get('vehicleno')?.disable();
      } else if (this.svtdetailsformgroup.get('vinnumber')?.value === '') {
        this.svtdetailsformgroup.get('vehicleno')?.enable();
      }
    });

    this.callBacketailsformgroup.get('hr')?.valueChanges.forEach(val => {
      this.callBacketailsformgroup.get('remarks')?.value;
      if (this.callBacketailsformgroup.get('hr')?.value !== '') {
        this.callBacketailsformgroup.get('dobv')?.disable();
        this.callBacketailsformgroup.get('time')?.disable();
      } else if (this.svtdetailsformgroup.get('hr')?.value === '' || this.svtdetailsformgroup.get('hr')?.value === null) {
        this.callBacketailsformgroup.get('dobv')?.enable();
        this.callBacketailsformgroup.get('time')?.enable();
      }
    });

    this.svtdetailsformgroup.get('dobv')?.valueChanges.forEach(val => {
      if (this.svtdetailsformgroup.get('dobv')?.value !== '' || this.svtdetailsformgroup.get('time')?.value !== '') {
        this.svtdetailsformgroup.get('hr')?.disable();
      } else if (this.svtdetailsformgroup.get('dobv')?.value === '' && this.svtdetailsformgroup.get('time')?.value !== '') {
        this.svtdetailsformgroup.get('hr')?.enable();
      }
    });

    this.svtdetailsformgroup.get('time')?.valueChanges.forEach(val => {
      if (this.svtdetailsformgroup.get('dobv')?.value !== '' || this.svtdetailsformgroup.get('time')?.value !== '') {
        this.svtdetailsformgroup.get('hr')?.disable();
      } else if (this.svtdetailsformgroup.get('dobv')?.value === '' && this.svtdetailsformgroup.get('time')?.value !== '') {
        this.svtdetailsformgroup.get('hr')?.enable();
      }
    });
    // if (code=80091) {
    //   this.showErrorMsg(message);
  }
  callmeResults() {
    throw new Error("Method not implemented.");
  }

  private _initializeControls() {
    this.svtdetailsformgroup = this.formBuilder.group({
      dobv: ['', [Validators.required]],
      phone: [
        '',
        [Validators.required,
        Validators.maxLength(CONSTANTS.FIELD_LENGTH.LAST_4_DIGITS),
        Validators.pattern(CONSTANTS.VALIDATION_TYPE.NUMERIC)]
      ],
      vehicleno: ['', [Validators.required, Validators.pattern(CONSTANTS.VALIDATION_TYPE.ALPHA_NUMERIC)]],
      vinnumber: ['',],
    });

    this.callBacketailsformgroup = this.formBuilder.group({
      dobv: [''],
      typev: ['', [Validators.required]],
      hr: [''],
      time: [''],
      remarks: [''],
    });
  }
  omit_chars(event: any) {
    this.key = event.charCode;
    return ((this.key >= 48 && this.key <= 57) || this.key === 45);
  }

  omit(event: any) {
    this.key = event.charCode;
    return ((this.key > 64 && this.key < 91) || (this.key > 96 && this.key < 123) || (this.key >= 48 && this.key <= 57));
  }
  /* omit_spl_chars(event) {
    this.key = event.charCode;
    return ((this.key > 64 && this.key < 91) || (this.key > 96 && this.key < 123) || (this.key >= 48 && this.key <= 57));
  } */
  // ----Data For Preferences PopUp----//
  setPreferencesPopUp() {
    this.customerInfo.preferenceData = this.modalConfig.popUpContent;
    if (!this.dashboardService.isEmptyObject(this.modalConfig.popUpContent)) {
      this.responseReceived = this.customerInfo.preferenceData.preferredContactDay.length !== 0 ? true : false;
      this.customerInfo.preferenceData.preferredContactDay = this.customerInfo.preferenceData.preferredContactDay;
    } else {
      this.responseReceived = false;
      this.customerInfo.preferenceData.preferredMethod = 'NA';
      this.customerInfo.preferenceData.preferredContactDay = 'NA';
      this.customerInfo.preferenceData.preferredContactStartTime = 'NA';
      this.customerInfo.preferenceData.preferredContactStartTime = 'NA';
    }
  }
  // ----Data For Preferences PopUp----//

  // ----Data For Trip Score PopUp-----//
  setTripScorePopUp() {
    if (!this.modalConfig.popUpContent.status) {
      this.responseReceived = false;
      this.showErrorMsg(this.modalConfig.popUpContent.content);
    } else {
      if (this.modalConfig.popUpContent !== '') {
        this.customerInfo.tripInfo = [];
        this.customerInfo.tripInfo = this.modalConfig.popUpContent.content;
        this.responseReceived = this.modalConfig.popUpContent.content.length !== 0 ? true : false;
      }
    }
  }
  // ----Data For Trip Score PopUp-----//

  // ----Data For DashBoad PopUp-----//
  setDashBoardPopUp() {
    if (!this.modalConfig.popUpContent.status) {
      this.responseReceived = false;
      this.showErrorMsg(this.modalConfig.popUpContent.content);
    } else {
      this.customerInfo.dashboardInfo = this.modalConfig.popUpContent.content;
      this.responseReceived = this.modalConfig.popUpContent.content !== '' ? true : false;
    }
  }
  // ----Data For DashBoad PopUp-----//

  // ----Data For SecurityAlaram PopUp-----//
  setSecurityAlaramDetails() {
    if (!this.modalConfig.popUpContent.status) {
      this.responseReceived = false;
      this.showErrorMsg(this.modalConfig.popUpContent.content);
    } else {
      this.customerInfo.securityAlarmDetails = this.modalConfig.popUpContent.content;
      this.responseReceived = this.modalConfig.popUpContent.content !== '' ? true : false;
    }
  }
  // ----Data For SecurityAlaram PopUp-----//

  // ----Data For RSA Popup -----------//
  setRSAPopUp() {
    if (!this.modalConfig.popUpContent.status) {
      this.responseReceived = false;
      this.showErrorMsg(this.modalConfig.popUpContent.content);
    } else {
      if (this.modalConfig.popUpContent.content !== '') {
        for (let i = 0; i < this.modalConfig.popUpContent.content.length; i++) {
          this.modalConfig.popUpContent.content[i].providerName = this.modalConfig.popUpContent.content[i].providerName == null ?
            'NA' : this.modalConfig.popUpContent.content[i].providerName;
          this.modalConfig.popUpContent.content[i].contactNo = this.modalConfig.popUpContent.content[i].contactNo == null ?
            'NA' : this.modalConfig.popUpContent.content[i].contactNo;
          this.modalConfig.popUpContent.content[i].rsaStartDt =
            this.modalConfig.popUpContent.content[i].rsaStartDt.replace(/(\d{4})(\d{2})(\d{2})/, '$3-$2-$1');
          this.modalConfig.popUpContent.content[i].rsaEndDt =
            this.modalConfig.popUpContent.content[i].rsaEndDt.replace(/(\d{4})(\d{2})(\d{2})/, '$3-$2-$1');
          this.customerInfo.rsaInfo[i] = this.modalConfig.popUpContent.content[i];
        }
        this.responseReceived = this.modalConfig.popUpContent.content.length !== 0 ? true : false;
      }
    }
  }
  // ----Data For RSA Popup -----------//

  // FUEL LOG POPUP
  setFuelLogPopup() {
    if (!this.modalConfig.popUpContent.status) {
      this.responseReceived = false;
      this.showErrorMsg(this.modalConfig.popUpContent.content);
    } else {
      if (this.modalConfig.popUpContent.content !== '') {
        console.log(this.modalConfig.popUpContent.content[0])
        for (let i = 0; i < this.modalConfig.popUpContent.content.length; i++) {
          this.modalConfig.popUpContent.content[i].fuelFillDate = this.modalConfig.popUpContent.content[i].fuelFillDate.replace(/(\d{4})(\d{2})(\d{2})/, '$3-$2-$1');
          this.modalConfig.popUpContent.content[i].fuelStation = this.modalConfig.popUpContent.content[i].fuelStation == null ? 'NA' : this.modalConfig.popUpContent.content[i].fuelStation;
          this.modalConfig.popUpContent.content[i].OdometerReading = this.modalConfig.popUpContent.content[i].OdometerReading == null ? 'NA' : this.modalConfig.popUpContent.content[i].OdometerReading;
          this.modalConfig.popUpContent.content[i].fuelAmount = this.modalConfig.popUpContent.content[i].fuelAmount == null ? 'NA' : this.modalConfig.popUpContent.content[i].fuelAmount;
          this.modalConfig.popUpContent.content[i].fuelFilled = this.modalConfig.popUpContent.content[i].fuelFilled == null ? 'NA' : this.modalConfig.popUpContent.content[i].fuelFilled;
          this.modalConfig.popUpContent.content[i].mileage = this.modalConfig.popUpContent.content[i].mileage == null ? 'NA' : this.modalConfig.popUpContent.content[i].mileage;
          this.modalConfig.popUpContent.content[i].litresOfFuel = this.modalConfig.popUpContent.content[i].litresOfFuel == null ? 'NA' : this.modalConfig.popUpContent.content[i].litresOfFuel;
        }
        this.fuelLogDetails = this.modalConfig.popUpContent.content;
        this.responseReceived = this.modalConfig.popUpContent.content.length !== 0 ? true : false;
      }
    }
  }

  setInsurancePopup() {
    if (!this.modalConfig.popUpContent.status) {
      this.responseReceived = false;
      this.showErrorMsg(this.modalConfig.popUpContent.content);
    } else {
      if (this.modalConfig.popUpContent.content !== '') {
        for (let i = 0; i < this.modalConfig.popUpContent.content.length; i++) {
          this.modalConfig.popUpContent.content[i].insuranceCompanyName = this.modalConfig.popUpContent.content[i].insuranceCompanyName == null ? 'NA' : this.modalConfig.popUpContent.content[i].insuranceCompanyName;
          this.modalConfig.popUpContent.content[i].issueDate = this.modalConfig.popUpContent.content[i].issueDate == null ? 'NA' : this.modalConfig.popUpContent.content[i].issueDate.replace(/(\d{4})(\d{2})(\d{2})/, '$3-$2-$1');
          this.modalConfig.popUpContent.content[i].policyType = this.modalConfig.popUpContent.content[i].policyType == null ? 'NA' : this.modalConfig.popUpContent.content[i].policyType;
          this.modalConfig.popUpContent.content[i].policyNumber = this.modalConfig.popUpContent.content[i].policyNumber == null ? 'NA' : this.modalConfig.popUpContent.content[i].policyNumber;
          this.modalConfig.popUpContent.content[i].policyStartDate = this.modalConfig.popUpContent.content[i].policyStartDate == null ? 'NA' : this.modalConfig.popUpContent.content[i].policyStartDate.replace(/(\d{4})(\d{2})(\d{2})/, '$3-$2-$1');
          this.modalConfig.popUpContent.content[i].policyEndDate = this.modalConfig.popUpContent.content[i].policyEndDate == null ? 'NA' : this.modalConfig.popUpContent.content[i].policyEndDate.replace(/(\d{4})(\d{2})(\d{2})/, '$3-$2-$1');
          this.modalConfig.popUpContent.content[i].policyStatus = this.modalConfig.popUpContent.content[i].policyStatus == null ? 'NA' : this.modalConfig.popUpContent.content[i].policyStatus;
          this.modalConfig.popUpContent.content[i].pucCompanyName = this.modalConfig.popUpContent.content[i].pucCompanyName == null ? 'NA' : this.modalConfig.popUpContent.content[i].pucCompanyName;
          this.modalConfig.popUpContent.content[i].pucEndDate = this.modalConfig.popUpContent.content[i].pucEndDate == null ? 'NA' : this.modalConfig.popUpContent.content[i].pucEndDate.replace(/(\d{4})(\d{2})(\d{2})/, '$3-$2-$1');
        }  
        this.insuranceDetails = this.modalConfig.popUpContent.content;
        this.responseReceived = this.modalConfig.popUpContent.content.length !== 0 ? true : false;
      }
    }
  }

  // ----Data For Transaction PopUp --------//
  setTransactionsPopUp() {
    if (!this.modalConfig.popUpContent.status) {
      this.responseReceived = false;
      this.showErrorMsg(this.modalConfig.popUpContent.content);
    } else {
      if (this.modalConfig.popUpContent.content !== '') {
        for (let i = 0; i < this.modalConfig.popUpContent.content.length; i++) {
          this.customerInfo.transInfo[i] = this.modalConfig.popUpContent.content[i];
        }
        this.responseReceived = this.modalConfig.popUpContent.content.length !== 0 ? true : false;
      }
    }
  }
  // ----Data For Transaction PopUp --------//


  // ----Data For Service History PopUp --------//
  setServiceHistoryPopUp() {
    if (!this.modalConfig.popUpContent.status) {
      this.responseReceived = false;
      this.showErrorMsg(this.modalConfig.popUpContent.content);
    } else {
      if (this.modalConfig.popUpContent.content !== '') {
        this.serviceDetails = this.modalConfig.popUpContent.content;
        this.responseReceived = true;
      }
    }
  }
  // ----Data For Transaction PopUp --------//

  changeInputForSVT(value: any, option: any) {
    if (option === 'vehicleNo') {
      if (value !== '') {
        this.svtdetailsformgroup.get('vinnumber')?.disable();
      } else if (value === '') {
        this.svtdetailsformgroup.get('vinnumber')?.enable();
      }
    } else {
      if (value !== '') {
        this.svtdetailsformgroup.get('vehicleno')?.disable();
      } else if (value === '') {
        this.svtdetailsformgroup.get('vehicleno')?.enable();
      }
    }
  }


  typeSelectOption(value: any, type: any) {
    if (type === 5) { 
      this.callBackValues.remarks = value;
    }if (type === 1) {
      this.callBackValues.type = value;
    } else if (type === 2) {
      if (value !== '') {
        this.callBackValues.hr = value;
        this.callBacketailsformgroup.get('dobv')?.disable();
        this.callBacketailsformgroup.get('time')?.disable();
      } else {
        this.callBacketailsformgroup.get('dobv')?.enable();
        this.callBacketailsformgroup.get('time')?.enable();
      }
    } else if (type === 3) {
      if (value === null) {
        if (this.callBacketailsformgroup.get('time')?.value !== '') {
          this.callBacketailsformgroup.get('hr')?.disable();
        } else {
          this.callBacketailsformgroup.get('hr')?.enable();
        }
      } else if (value !== null || value !== '') {
        this.callBacketailsformgroup.get('hr')?.disable();
      }
    } else if (type === 4) {
      if (value !== '') {
        this.callBacketailsformgroup.get('hr')?.disable();
      } else {
        if (this.callBacketailsformgroup.get('dobv')?.value !== '') {
          this.callBacketailsformgroup.get('hr')?.disable();
        } else {
          this.callBacketailsformgroup.get('hr')?.enable();
        }
      }
    }
  }

  createCallBack() {
    if (this.callBacketailsformgroup.invalid) {
      Object.keys(this.callBacketailsformgroup.controls).forEach(field => {
        const control = this.callBacketailsformgroup.get(field);
        control?.markAsTouched({ onlySelf: true });
      });
      return;
    }

    let formData = {};

    if (this.callBacketailsformgroup.value.hr && this.svtdetailsformgroup.value.hr !== '') {
      formData = {
        customerId: this.customerDetailsService.customerId,
        type: this.callBackValues.type,
        minutes: parseInt(this.callBackValues.hr, 10) * 60,
        vinNumber: this.customerDetailsService.vinNumber,
        remarks: this.callBacketailsformgroup.get('remarks')?.value
      };
    } else if ((this.callBacketailsformgroup.value.dobv && this.callBacketailsformgroup.value.dobv !== '') || (this.callBacketailsformgroup.value.time && this.callBacketailsformgroup.value.time !== '')) {
      formData = {
        customerId: this.customerDetailsService.customerId,
        type: this.callBackValues.type,
        date: this.datepipe.transform(this.callBacketailsformgroup.value.dobv, 'yyyy-MM-dd'),
        time: this.callBacketailsformgroup.value.time,
        vinNumber: this.customerDetailsService.vinNumber,
        remarks: this.callBacketailsformgroup.get('remarks')?.value
      };
    }

    this.customerDetailsService.createCallBackDetails(formData).subscribe(returnData => {
      if (returnData.status.status) {
        this.showErrorMsg(returnData.status.message);
      } else {
       if (returnData.status.code === 50008) {
          this.dashboardService.backToLogin();
        } else {
          this.showErrorMsg(returnData.status.message);
        }
      }
    }, (error) => {
      console.error('Error in getting Update Call back', error);
      if (error.status === 401 || error.status === 402) {
        this.dashboardService.unauthorizedLogoutMsg = error.status.message;
        this.dashboardService.backToLogin();
      } else {
        this.showErrorMsg(error.statusText);
      }
    });
  }

  // ---getting SVTStatus()-------------------//
  getSVTStatus() {
    if (this.svtdetailsformgroup.invalid) {
      Object.keys(this.svtdetailsformgroup.controls).forEach(field => {
        const control = this.svtdetailsformgroup.get(field);
        control?.markAsTouched({ onlySelf: true });
      });
      return;
    }

    // if ((this.svtDetails.vehRegNumber.length === 0 && this.svtDetails.vinNumber.length !== 0) ||
    //   (this.svtDetails.vehRegNumber.length !== 0 && this.svtDetails.vinNumber.length === 0)) { }

    this.svterror = false;
    this.svtDetails.dateOfBirth = this.datepipe.transform(this.svtdetailsformgroup.value.dobv, 'yyyy-MM-dd');

    let formData = {};

    if (this.svtdetailsformgroup.value.vehicleno && this.svtdetailsformgroup.value.vehicleno !== '') {
      formData = {
        dateOfBirth: this.datepipe.transform(this.svtdetailsformgroup.value.dobv, 'yyyy-MM-dd'),
        primaryMobileNo: this.svtdetailsformgroup.value.phone,
        vehRegNumber: this.svtdetailsformgroup.value.vehicleno.toUpperCase()
      };
    } else if (this.svtdetailsformgroup.value.vinnumber && this.svtdetailsformgroup.value.vinnumber !== '') {
      formData = {
        dateOfBirth: this.datepipe.transform(this.svtdetailsformgroup.value.dobv, 'yyyy-MM-dd'),
        primaryMobileNo: this.svtdetailsformgroup.value.phone,
        vinNumber: this.svtdetailsformgroup.value.vinnumber.toUpperCase()
      };
    }



    this.customerDetailsService.getSVTDetails(formData).subscribe(returnData => {
      if (returnData.status.status) {
        if (Object.keys(returnData.data).length !== 0) {
          this.svtUserDetails = returnData.data;
          this.oneTimeStartOrStopSVT = true;
          if (this.svtUserDetails.trackingStatus === 'start') {
            // this.isSVTPopUp = true;
            this.modalConfig.popupId = 'svtOn';
          } else if (this.svtUserDetails.trackingStatus === 'stop') {
            // this.isSVTPopUp = true;
            this.modalConfig.popupId = 'svtOff';
          } else {
            this.currentSVTStatus = this.svtUserDetails.trackingStatus === 'inProgress-stop' ? 'on' : 'off';
            this.checkSVTStatus = this.svtUserDetails;
            this.checkSVTStatus.requestId = localStorage.getItem(this.svtUserDetails.vinNumber);
            this.checkForSVTStatus();
          }
          this.pageTitle = this.modalConfig.popUpToShow;
        } else {
          this.showErrorMsg(returnData.status.message);
        }
      } else {
        if (returnData.status.code === 50008) {
          this.dashboardService.backToLogin();
        } else {
          this.showErrorMsg(returnData.status.message);
        }
      }
    }, (error) => {
      console.error('Error in getting SVT Details', error);
      if (error.status === 401 || error.status === 402) {
        this.dashboardService.unauthorizedLogoutMsg = error.status.message;
        this.dashboardService.backToLogin();
      } else {
        this.showErrorMsg(error.statusText);
      }
    });
    // } else {
    //   this.svterror = true;
    // }
  }
  // ---getting SVTStatus()-------------------//

  // ---Start or Stop SVT-------------------//
  startOrStopSVT(svtStatus) {
    const startStopSVT = {
      command: svtStatus,
      vinNumber: this.svtUserDetails.vinNumber,
      productOwnId: this.svtUserDetails.productOwnId,
      customerId: this.svtUserDetails.customerId
    };
    this.customerDetailsService.startStopSVT(startStopSVT).subscribe(returnSVTStatusData => {
      if (returnSVTStatusData.status.status) {
        localStorage.setItem(this.svtUserDetails.vinNumber, returnSVTStatusData.data.requestId);
        this.checkSVTStatus = this.svtUserDetails;
        this.checkSVTStatus.requestId = returnSVTStatusData.data.requestId;
        this.currentSVTStatus = svtStatus;
        this.isSVTPopUp = false;
        this.modalConfig.popupId = 'checkSVT';
        this.pageTitle = this.modalConfig.popUpToShow;
      } else {
        if (returnSVTStatusData.status.code === 50008) {
          this.dashboardService.backToLogin();
        }
      }
    }, (error) => {
      console.error('Error in StartOrStopSVT Api call', error);
      if (error.status === 401 || error.status === 402) {
        this.dashboardService.unauthorizedLogoutMsg = error.status.message;
        this.dashboardService.backToLogin();
      } else {
        this.showErrorMsg(error.statusText);
      }
    });
  }
  // ---Start or Stop SVT-------------------//
  // ---Check SVT Status -------------------//
  checkForSVTStatus() {
    // this.checkSVTStatus.emailId = 'basavask@in.ibm.com';
    this.customerDetailsService.checkSVTStatus(this.checkSVTStatus).subscribe(returnSVTData => {
      if (!returnSVTData.status.status) {
        if (returnSVTData.status.message === 'SVT on failed!' || returnSVTData.status.statusCode === 60001) {
          this.svtCheckStatus = false;
        } else if (returnSVTData.status.status.code === 50008) {
          this.dashboardService.backToLogin();
        } else {
          this.svtCheckStatus = true;
        }
        this.showErrorMsg(returnSVTData.status.message);
      } else if (!returnSVTData.status) {
        this.showErrorMsg(returnSVTData.message);
      } else {
        if (this.currentSVTStatus === 'on') {
          this.isSVTPopUp = true;
          console.log('returnSVTData.data.url', returnSVTData.data.url);
          this.svtLocationUrl = this.sanitizer.bypassSecurityTrustUrl(returnSVTData.data.url);
          this.modalConfig.popupId = 'svtOn';
        } else if (this.currentSVTStatus === 'off') {
          this.isSVTPopUp = true;
          this.modalConfig.popupId = 'svtOff';
        } else {
          this.isSVTPopUp = true;
          console.log('returnSVTData.data.url', returnSVTData.data.url);
          this.svtLocationUrl = this.sanitizer.bypassSecurityTrustUrl(returnSVTData.data.url);
          this.modalConfig.popupId = returnSVTData.data.svtStatus === 'start' ? 'svtOn' : 'svtOff';
          this.pageTitle = this.modalConfig.popUpToShow;
        }
        this.oneTimeStartOrStopSVT = false;
      }
    }, (error) => {
      console.error('Error white checking svt status...', error);
      if (error.status === 401 || error.status === 402) {
        this.dashboardService.unauthorizedLogoutMsg = error.status.message;
        this.dashboardService.backToLogin();
      } else {
        this.showErrorMsg(error.statusText);
      }
    });
  }
  // ---Check SVT Status -------------------//

  getSvtLocationUrl() {
    return this.svtLocationUrl;
  }
  // --Search ------------------------------//
  search(startDate, endDate) {
    console.log(startDate, endDate);
    if (startDate === undefined || endDate === undefined) {
      this.showDateErrMsg = true;
      this.errorMessage = 'Please select the From date and To date';
    } else {
      this.dashboardService.dashboardEvent({
        proceed: true,
        startDate,
        endDate
      });
      this.activeModal.dismiss('Modal Closed');
    }

  }
  // --Search ------------------------------//

  // --page --------------------------------//
  pageChanged(event) {
    this.page = event;
  }
  // --page --------------------------------//

  // --For Showing Error Msg on Screen-----//
  showErrorMsg(errMsg) {
    this.errorMessage = errMsg;
    this.modalConfig.popupId = PopUpId.ERRMSGPOP;
    this.pageTitle = this.modalConfig.popUpToShow;
  }
  // --For Showing Error Msg on Screen-----//

  // --Close Svt Window -------------------//
  close(): void {
    if (this.svtCheckStatus) {
      this.svtCheckStatus = false;
      this.modalConfig.popupId = 'checkSVT';
      this.isSVTPopUp = false;
      this.pageTitle = this.modalConfig.popUpToShow;
    } else {
      if (this.isSVTPopUp) {
        localStorage.setItem('pageName', 'svt');
        localStorage.setItem('vinNumber', this.svtUserDetails.vinNumber);
        this.router.navigate(['/dashboard/customerMapIntegration']);
      }
      this.activeModal.dismiss('Modal Closed');
      this.element.style.display = 'block';
      document.body.classList.remove('hc-modal-open');
    }
  }
  // --Close Svt Window -------------------//

  onDateValueChange(value: Date, option: any): void {
    if (option === 'from') {
      // this.minDate = value;
      if (value > this.endDate) {
        this.showDateErrMsg = true;
        this.errorMessage = 'Please check the From date is greater than To date';
        this.isFetechDateEnable = true;
      } else {
        if (this.endDate !== undefined) {
          this.isFetechDateEnable = false;
        }
        this.showDateErrMsg = false;
      }
    } else {
      if (value < this.startDate) {
        this.showDateErrMsg = true;
        this.isFetechDateEnable = true;
        this.errorMessage = 'Please check the To date is less than From date';
      } else {
        if (this.startDate !== undefined) {
          this.isFetechDateEnable = false;
        }
        this.showDateErrMsg = false;
      }
    }
  }

  callCustomer(value) {
    const formData = {
      vinNumber: localStorage.getItem('vinNumber'),
      mobileNo: value.mobileNo
    };
    this.dashboardService.callCustomerCTI(formData).subscribe(data => {
      console.log('Cti Response::', data);
    }, (error) => {
      console.error('Error Manual Dialing', error);
      this.errorHandler(error);
    });
  }

  emCallCustomer(value) {
    const formData = {
      vinNumber: localStorage.getItem('vinNumber'),
      mobileNo: value.emMobileNumber
    };
    this.dashboardService.callCustomerCTI(formData).subscribe(data => {
      console.log('Cti Response::', data);
    }, (error) => {
      console.error('Error Manual Dialing', error);
      this.errorHandler(error);
    });
  }

  errorHandler(error) {
    if (error.status === 401) {
      // this.dashboardService.openModal('Error', PopUpId.ERRMSGPOP, 'Unauthorized');
      this.dashboardService.backToLogin();
    } else {
      this.dashboardService.openModal('Error', PopUpId.ERRMSGPOP, error.statusText);
    }
  }

  //CTI connection for callBack 
  callbackResults() {
    this.callbackData = this.customerDetailsService.callbackResults;
    console.log('search page in call-back', this.callbackData);
    if (this.customerDetailsService.callbackResults.length === 0) {
      this.zeroResults = true;
    } else if (this.customerDetailsService.callbackResults.length > 1) {
      this.zeroResults = false;
    }
  }


  navigateCallBack(option) {
console.log('#####', option);
    const formData = {
      id: option.id,
      type: option.callbackType,
      vinNumber: option.vinNumber
    };
    this.customerDetailsService.callbackListUpdate(formData).subscribe(
      (result) => {
        if (result.status.status) {
          // this.dashboardService.dashboardEvent({
          //   callbackClick: true,
          //   phone: option.primaryMobileNo
          // });
          localStorage.setItem('selectedVinNumber', option.vinNumber);
          localStorage.setItem('vinNumber', option.vinNumber);
          this.router.navigate(['/dashboard/customerMapIntegration']);
          this.activeModal.dismiss('Modal Closed');
        } else {
          this.dashboardService.openModal('Call back', 'apiError', result.status.message);
        }
      }, (error) => {
        console.error('Error at Customer Api ...', error);
        if (error.status === 401 || error.status === 402) {
          this.dashboardService.unauthorizedLogoutMsg = error.status.message;
          // this.dashboardService.openModal('Error', PopUpId.ERRMSGPOP, 'Unauthorized');
          this.dashboardService.backToLogin();
        } else {
          this.dashboardService.openModal('Error', PopUpId.ERRMSGPOP, error.statusText);
        }
      });
  }

}

